/* Protocol Nutrition: small behaviours for the pn- sections. */
(function () {
  // Reveal on scroll (skipped in the theme editor)
  var design = window.Shopify && Shopify.designMode;
  var io = !design && 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  function scan(root) { (root || document).querySelectorAll('.pn-reveal:not(.is-in)').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); }); }
  if (io) document.documentElement.classList.add('pn-js');
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  // Product gallery thumbnails
  document.querySelectorAll('[data-pn-gallery]').forEach(function (g) {
    var main = g.querySelector('.pn-pdp__main-img img');
    if (!main) return;
    g.querySelectorAll('[data-pn-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.dataset.src; main.srcset = btn.dataset.srcset || '';
        g.querySelectorAll('[data-pn-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Subscribe / one-off picker: sets selling_plan and updates button price
  document.querySelectorAll('[data-pn-plan-form]').forEach(function (form) {
    var input = form.querySelector('input[name="selling_plan"]');
    var label = form.querySelector('[data-pn-atc-price]');
    var sticky = document.querySelector('[data-pn-sticky-price]');
    form.querySelectorAll('input[name="pn_plan"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (input) input.value = r.value || '';
        if (input) input.disabled = !r.value;
        if (label) label.textContent = r.dataset.price;
        if (sticky) sticky.textContent = r.dataset.price;
      });
    });
  });

  // Sticky add-to-cart on mobile
  var atc = document.querySelector('[data-pn-atc]');
  var bar = document.querySelector('[data-pn-sticky]');
  if (atc && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { bar.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(atc);
    bar.querySelector('button').addEventListener('click', function () { atc.click(); });
  }
})();
